import { thsI18NJsBridge } from '@fs/jsbridge'
import { addCurParamsForUrl } from '@/utils/utils.js'

export default (url, title = '') => {
    if (thsI18NJsBridge.isTHSI18NApp()) {
        const newUrl = addCurParamsForUrl(url)
        console.log('newUrl:', newUrl, title)
        // console.log('openPageInl18NTHS title:', title)
        // console.log('openPageInl18NTHS url:', url)
        // if (title === '复星国际证券开户') {
        //     title = FISL_ACCOUNT_OPEN_TITLE
        // }
        title ? thsI18NJsBridge.gotoCommonPage({ url: newUrl, title }) : thsI18NJsBridge.gotoCommonPage({ url: newUrl })
        return true
    }
    return false
}
